import Vue from 'vue';
import SurveyRespondentDetails from '@/plugins/graphql/queries/v2/survey/survey-respondent-details.gql';
import { SurveyRespondentDetailsModel } from '@/helpers/entities/models/SurveyRespondentDetailsModel';
export default Vue.extend({
    apollo: {
        surveyRespondentDetails: {
            query: SurveyRespondentDetails,
            variables() {
                return {
                    pageRecipientUuid: this.pageRecipientUuid,
                };
            },
            update(data) {
                return new SurveyRespondentDetailsModel(data.pageRecipient);
            },
        },
    },
    props: {
        pageRecipientUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            surveyRespondentDetails: null,
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                surveyRespondentDetails: this.surveyRespondentDetails,
            });
        }
    },
});
